// Lightweight first-party analytics tracker (feeds the admin live dashboard).
import api from "./api";

const SID_KEY = "smarti_sid";

function sessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

function detectSource() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = p.get("utm_source");
    if (utm) {
      const m = (p.get("utm_medium") || "").toLowerCase();
      if (m.includes("cpc") || m.includes("paid") || utm.toLowerCase().includes("ads")) return "google_ads";
      return utm.toLowerCase();
    }
    const ref = document.referrer || "";
    if (!ref) return "direct";
    const h = new URL(ref).hostname.replace("www.", "");
    if (h.includes("google")) return "google";
    if (h.includes("facebook") || h.includes("instagram") || h.includes("fb.")) return "meta";
    if (h.includes(window.location.hostname)) return "direct";
    return h;
  } catch {
    return "direct";
  }
}

function device() {
  return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? "mobile" : "desktop";
}

let _source = null;
export function track(event, extra = {}) {
  try {
    if (_source === null) _source = detectSource();
    api.post("/track", {
      session_id: sessionId(),
      event,
      path: window.location.pathname,
      referrer: document.referrer || "",
      source: _source,
      device: device(),
      ...extra,
    }).catch(() => {});
  } catch { /* noop */ }
}

export function trackPageView() {
  track("page_view");
}
